export const environment = {
    version: '1.1.0 - Homologação',
    production: true, // Define se a aplicação está no modo de desenvolvimento
    api: 'https://painel-financeiro-api-hom.cfm.org.br/api/v1/financeiro', // Valor padrão para desenvolvimento
    recebidos: '/recebidos/analitico',
    pessoa: '/pessoa/',
    inadimplentes: '/inadimplentes',
    redirectUri: 'https://painelfinanceiro-hom.cfm.org.br',
    keycloak: 'https://auth-hom.cfm.org.br/realms/CFM',
    urlkeycloackrefresh: 'https://auth-hom.cfm.org.br/realms/CFM/protocol/openid-connect/token',
    clientId: 'painel-financeiro-web',
  };
